import React, { createContext, useContext, useMemo, useState } from 'react';

type AdminHeaderActionsContextValue = {
  actions: React.ReactNode;
  setActions: (actions: React.ReactNode) => void;
};

const AdminHeaderActionsContext = createContext<AdminHeaderActionsContextValue | null>(null);

export const AdminHeaderActionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [actions, setActions] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);

  return (
    <AdminHeaderActionsContext.Provider value={value}>
      {children}
    </AdminHeaderActionsContext.Provider>
  );
};

export function useAdminHeaderActions(): AdminHeaderActionsContextValue {
  const context = useContext(AdminHeaderActionsContext);
  if (!context) {
    throw new Error('useAdminHeaderActions must be used within AdminHeaderActionsProvider');
  }
  return context;
}

export const AdminHeaderActionsSlot: React.FC = () => {
  const { actions } = useAdminHeaderActions();
  if (!actions) return null;

  return (
    <div className="ml-4 shrink-0 flex items-center gap-3 flex-wrap justify-end">
      {actions}
    </div>
  );
};
